// extracted by mini-css-extract-plugin
export var progressContainer = "_fr-0";